var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkArLng({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5735 23.4083C40.1559 17.6447 40.2488 12.0943 40.0789 6.24822C40.0459 5.1065 40.9427 4.15731 42.081 4.12292C43.22 4.08853 44.1705 4.98955 44.2042 6.13127C44.3652 11.6748 44.2352 16.95 45.5804 22.4247C45.8528 23.532 45.1753 24.6531 44.0694 24.9214C42.9641 25.1965 41.8451 24.5156 41.5735 23.4083Z",
    fill: "#12141D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5306 34.5788C19.9141 25.789 10.8533 14.4819 4.52018 3.06476C3.96789 2.06748 4.32762 0.808792 5.32353 0.258568C6.31943 -0.291656 7.57668 0.066021 8.12897 1.0633C14.253 12.1022 23.0159 23.0379 32.3147 31.532C33.1552 32.3023 33.2136 33.609 32.4454 34.4481C31.6771 35.2872 30.3711 35.3491 29.5306 34.5788Z",
    fill: "#12141D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.095 44.1789C18.2997 45.6301 9.23404 43.1541 1.23654 39.6533C0.193181 39.1925 -0.282776 37.9752 0.173221 36.9366C0.629907 35.8912 1.84798 35.4166 2.89134 35.8705C10.1749 39.0618 18.4125 41.4278 26.423 40.1073C27.5469 39.9216 28.6095 40.685 28.7945 41.8061C28.9802 42.9272 28.2181 43.9932 27.095 44.1789Z",
    fill: "#12141D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkArLng);
export default __webpack_public_path__ + "static/media/sparkArLng.9bc1ce69cd79bed335edfacda8aeb247.svg";
export { ForwardRef as ReactComponent };